import GetLoading from "../../share/getLoading";
// import { useEffect, useState } from "react";
// import {
//   PlusCircleOutlined,
//   CheckCircleOutlined,
//   ClockCircleOutlined,
//   UsergroupAddOutlined,
//   EditFilled,
//   DeleteFilled,
// } from "@ant-design/icons";
// import {
//   Modal,
//   Button,
//   Form,
//   Input,
//   Item,
//   UserOutlined,
//   Select,
//   Space,
//   Tag,
//   Checkbox,
//   Pagination,
// } from "antd";
// import "../../styles/Home-module.css";
// import styles from "../../styles/Font.css";
// import { request } from "../../share/request";
// import Table from "react-bootstrap/Table";
// import { Stack } from "react-bootstrap";

// import { openNotification } from "../../share/message";

// import { getCurrentUser, getPermission } from "../../share/getProfile";
// import { getTageStyle } from "../../share/getStatusContent";
// 
// import { boxHeader, boxHeaderTagText } from "../../styles/boxShadow";

// const { Option } = Select;
// const Position = () => {
//   const getProfileOrg = getCurrentUser();
//   const [list, setList] = useState([]);
//   const [listdepart, setListDepart] = useState([]);
//   const [id, setID] = useState("");
//   const [position, setPosition] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [loadingSpin, setLoadingSpin] = useState(false);

//   const [objFilter, setObjFilter] = useState({
//     page: 1,
//     department_code: "",
//     org_code: getProfileOrg.org_code,
//   });
//   // -----------------  permisstion page --------------------
//   const userPermission = getPermission();
//   const positionValue = userPermission.find(
//     (permission) => permission.pagename === "position"
//   ) || { add: 0, edit: 0, deleted: 0 };
//   const {
//     add: addvalue,
//     edit: Editvalue,
//     deleted: deletevalue,
//   } = positionValue;
//   // -----------------  end permisstion page --------------------

//   // const getList = async (objFilter) => {
//   //   const param = new URLSearchParams({
//   //     page: objFilter.page,
//   //     department_code: objFilter.department_code,
//   //     org_code: getProfileOrg.org_code,
//   //   });
//   //   try {
//   //     await new Promise((resolve) => setTimeout(resolve, 400));
//   //     const res = await request("position?" + param, "get", {});
//   //     if (res) {
//   //       setList(res.listPosition);
//   //       setListDepart(res.listDepart);
//   //     }
//   //   } catch (error) {
//   //     console.error("Error fetching data:", error);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };
//   const getList = async (objFilter) => {
//     // Construct query parameters
//     const param = new URLSearchParams({
//       page: objFilter.page,
//       department_code: objFilter.department_code,
//       org_code: getProfileOrg.org_code, // Using the org_code from user profile
//     });
//     console.log("Parameters for department:", param.toString());
//     try {
//       // Simulate a delay for demonstration (remove in production)
//       await new Promise((resolve) => setTimeout(resolve, 400));

//       // Make the API request
//       const res = await request("position?" + param.toString(), "get", {});

//       // Check if the response contains data
//       if (res) {
//         setList(res.listPosition); // Update state with the list of positions
//         setListDepart(res.listDepartment); // Update state with the list of departments
//         setTotalPage(res.total_records);
//       }
//     } catch (error) {
//       // Log any errors encountered during the fetch
//       console.error("Error fetching data:", error);
//     } finally {
//       // Set loading state to false when the request is done
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     // block form load
//     getList(objFilter);
//   }, []);
//   //-------------- page management ----------------------
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentData = list.slice(indexOfFirstItem, indexOfLastItem);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };
//   //-------------------------------------------

//   // ----------------- open modle ----------
//   const [visableModelDelete, setVisableModeleDelete] = useState(false);
//   const onDeleteModel = (item) => {
//     setVisableModeleDelete(true);
//     setID(item.id);
//     setPosition(item.position_kh);
//   };
//   const onCLoseModelDelete = () => {
//     setVisableModeleDelete(false);
//   };
//   const onComfirmModelDelete = async () => {
//     console.log("ID delete is : " + id);
//     const res = await request("position/" + id, "delete", {});
//     setVisableModeleDelete(false);
//     if (res) {
//       getList(objFilter);
//       setLoadingSpin(true);
//       await new Promise((resolve) => setTimeout(resolve, 400));
//       openNotification("success", "Success", "Delete Success !");
//     } else {
//       alert("Error!");
//     }
//     setLoadingSpin(false);
//   };
//   // --------------- end model delete--------

//   //---------------- statuse --------------
//   const getStatusContent = (status) => {
//     switch (status) {
//       case 1:
//         return (
//           <Button
//             type="primary"
//             ghost
//             shape="round"
//             icon={<CheckCircleOutlined />}
//           >
//             {" "}
//             Enable{" "}
//           </Button>
//         );
//       case 0:
//         return (
//           <Button
//             type="primary"
//             danger
//             ghost
//             shape="round"
//             icon={<ClockCircleOutlined />}
//           >
//             {" "}
//             Disable{" "}
//           </Button>
//         );

//       default:
//         return null;
//     }
//   };
//   // ------------- end status----------

//   //------------- style tage --------
//   const styleTageStatus = {
//     fontSize: "14px",
//     height: "30px",
//     borderRadius: "30px",
//     paddingTop: "5px",
//     paddingLeft: "10px",
//     paddingRight: "10px",
//   };

//   //---------------------------

//   //------------- save ----------
//   const [visableNewModel, setVisableNewModel] = useState(false);
//   const onOpenSaveNew = () => {
//     setID("");
//     setVisableNewModel(true);
//     setEnable(true);
//     setDisable(false);

//     setDepartment("");
//     setPosition_KH("");
//     setPosition_EN("");
//     setOther("");
//   };
//   const onCLoseNewDataModel = () => {
//     setVisableNewModel(false);
//   };
//   //-------------   enable and disable ---------------

//   const [enable, setEnable] = useState(false);
//   const [disable, setDisable] = useState(false);
//   const handleCheckboxChange_Enable = (e) => {
//     setEnable(e.target.checked);
//     setDisable(false);
//   };
//   const handleCheckboxChange_Diable = (e) => {
//     setDisable(e.target.checked);
//     setEnable(false);
//   };
//   //--------------------------------------------

//   //------------------- save data to position--------
//   const [department, setDepartment] = useState("");
//   const [code, setCode] = useState("");
//   const [position_kh, setPosition_KH] = useState("");
//   const [position_en, setPosition_EN] = useState("");
//   const [other, setOther] = useState("");
//   const [TotalPage, setTotalPage] = useState("");
//   //   const [status,setStatus]=useState(1);
//   const onSaveData = async () => {
//     if (id == "") {
//       var data = {
//         code: code,
//         position_kh: position_kh,
//         position_en: position_en,
//         des: other,
//         status: enable == true ? 1 : disable == true ? 0 : 0,
//         user_create: getProfileOrg.fullname,
//       };
//       const res = request("position", "post", data);
//       setVisableNewModel(false);
//       if (res) {
//         setLoadingSpin(true);
//         await new Promise((resolve) => setTimeout(resolve, 400));
//         openNotification("success", "Success", "Save Position Success");
//       } else {
//         alert("Error!");
//       }
//       getList(objFilter); // re call function list
//       setLoadingSpin(false);
//     } else {
//       var data = {
//         id: id,
//         code: code,
//         position_kh: position_kh,
//         position_en: position_en,
//         des: other,
//         status: enable == true ? 1 : disable == true ? 0 : 1,
//         user_create: getProfileOrg.fullname,
//       };
//       const res = request("position", "put", data);
//       setVisableNewModel(false);
//       if (res) {
//         setLoadingSpin(true);
//         await new Promise((resolve) => setTimeout(resolve, 400));
//         openNotification("success", "Success", "Update Position Success");
//       } else {
//         alert("Error!");
//       }
//       getList(objFilter); // re call function list
//       setLoadingSpin(false);
//     }
//   };
//   //   const onSaveData = async () => {
//   //     const isNew = id === "";
//   //     const data = {
//   //         id: isNew ? id : undefined,
//   //         code: department,
//   //         position_kh,
//   //         position_en,
//   //         des: other,
//   //         status: enable ? 1 : 0,
//   //         user_create: isNew ? "System create" : "System update"
//   //     };

//   //     const method = isNew ? "post" : "put";
//   //     const res = await request("position", method, data);

//   //     setVisableNewModel(false);
//   //     if (res) {
//   //         getList();
//   //         setLoadingSpin(true);
//   //         await new Promise(resolve => setTimeout(resolve, 400));
//   //         openNotification('success', 'Success', isNew ? 'Save Position Success' : 'Update Position Success');
//   //     } else {
//   //         alert("Error!");
//   //     }
//   //     setLoadingSpin(false);
//   // };

//   const onChangeKH = (event) => {
//     setPosition_KH(event.target.value);
//   };
//   const onChangeEN = (event) => {
//     setPosition_EN(event.target.value);
//   };
//   const onChangeOther = (event) => {
//     setOther(event.target.value);
//   };
//   const onChangeDepartment = async (value) => {
//     setCode(value);
//     console.log(value);
//     setCurrentPage(1);
//     try {
//       setLoadingSpin(true);

//       var objTmp = {
//         ...objFilter,
//         department_code: value, // Set the department name
//         page: 1, // Set page to 1 if input is empty, otherwise retain current page
//       };

//       setObjFilter(objTmp); // Update the filter state
//       getList(objTmp); // Fetch the updated list
//       await new Promise((resolve) => setTimeout(resolve, 400));
//     } catch (error) {
//     } finally {
//       setLoadingSpin(false); //
//     }
//   };
//   const onChangeDepartmentNew = (value) => {
//     setCode(value);
//   };
//   //--------------------

//   //--------------- Eidt data ----------
//   const onOpenEdit = (item) => {
//     setID(item.id);
//     setCode(item.code);
//     setDepartment(item.code + " -" + item.department_name);
//     setPosition_KH(item.position_kh);
//     setPosition_EN(item.position_en);
//     setOther(item.des);
//     setVisableNewModel(true);
//     if (item.status === 1) {
//       return setEnable(true), setDisable(false);
//     } else {
//       return setEnable(false), setDisable(true);
//     }
//   };

//   //-------------------------
//   const onCancelModel = () => {
//     setVisableNewModel(false);
//   };
//   const onCanceDelete = () => {
//     setVisableModeleDelete(false);
//   };

//   const [pageNumber, setPageNumber] = useState(1);
//   const onShowSizeChange = async (current) => {
//     console.log(current);
//     setPageNumber(current);
//     try {
//       setLoadingSpin(false);
//       var objTmp = {
//         ...objFilter,
//         page: current,
//       };
//       await new Promise((resolve) => setTimeout(resolve, 400));
//       setObjFilter(objTmp);
//       getList(objTmp);
//     } catch (error) {
//     } finally {
//       setLoadingSpin(false);
//     }
//   };

//   return (
//     <div>
//       <div className="sprinSave-container">
//         {/* Your other components */}
//         {loadingSpin && (
//           <div className="sprinSave">
//             <GetLoading />
//           </div>
//         )}
//       </div>

//       <div style={boxHeader}>
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "row",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           {boxHeaderTagText("ការគ្រប់គ្រង់ ព៏តមានតួនាទី")}
//           <Select
//             className="styleTageStatusForm"
//             placeholder="Select an Deparment"
//             style={{ width: 250 }}
//             onChange={onChangeDepartment}
//             allowClear
//           >
//             {listdepart.map((option) => (
//               <Option
//                 className="styleTageStatusForm"
//                 key={option.code}
//                 value={option.code}
//               >
//                 {option.department_name}{" "}
//                 {/* Replace with the field from your MySQL table */}
//               </Option>
//             ))}
//           </Select>
//         </div>
//         <Button
//           onClick={onOpenSaveNew}
//           disabled={!addvalue}
//           className="custom-form-item"
//           type="primary"
//           icon={<PlusCircleOutlined />}
//         >
//           បន្ថែមតួនាទីថ្មី
//         </Button>
//       </div>

//       <div>
//         {loading ? (
//           <div className="sprinCustome">
//             <GetLoading />
//           </div>
//         ) : (
//           <Table
//             // striped
//             // bordered
//             // hover
//             className="rounded-table"
//             itemsPerPage={10}
//           >
//             <thead>
//               <tr class="table-success">
//                 <th>NO</th>
//                 <th>ផ្នែក</th>
//                 <th>តួនាទី ភាសាខ្មែរ</th>
//                 <th>តួនាទី English</th>
//                 <th>ផ្សេងៗ</th>
//                 <th>ស្ថានភាព</th>
//                 <th>អ្នកបង្កើត</th>
//                 <th>សកម្មភាព</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentData.map((item, index) => (
//                 <tr key={index}>
//                   <td>{10 * (pageNumber - 1) + (index + 1)}</td>
//                   <td>{getTageStyle(item.department_name)}</td>
//                   <td>{item.position_kh}</td>
//                   <td>{item.position_en}</td>
//                   <td>{item.des}</td>
//                   <td>{getStatusContent(item.status)}</td>
//                   <td>
//                     <Tag
//                       style={styleTageStatus}
//                       icon={<UsergroupAddOutlined />}
//                       color="green"
//                     >
//                       {item.user_create}
//                     </Tag>
//                   </td>

//                   <td style={{ width: 100 }}>
//                     <Stack gap={1} direction="horizontal">
//                       <Button
//                         icon={<EditFilled />}
//                         disabled={!Editvalue}
//                         type="primary"
//                         onClick={() => onOpenEdit(item)}
//                       >
                          
//                       </Button>{" "}
//                       <Button
//                         icon={<DeleteFilled />}
//                         disabled={!deletevalue}
//                         type="primary"
//                         onClick={() => onDeleteModel(item)}
//                         danger
//                       >
                         
//                       </Button>
//                     </Stack>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//         )}

//         <Pagination
//           //   showSizeChanger
//           onChange={onShowSizeChange}
//           defaultCurrent={currentPage}
//           total={TotalPage}
//         />

//         <Modal
//           title={id == "" ? "New Position" : "Update Position"}
//           className="styleTageStatusForm"
//           open={visableNewModel}
//           onCancel={onCancelModel}
//           footer={[
//             <div>
//               <Space>
//                 <Button onClick={onCLoseNewDataModel}>Cancel</Button>
//                 <Button type="primary" onClick={onSaveData}>
//                   {id == "" ? "Save" : "Update"}
//                 </Button>
//               </Space>
//             </div>,
//           ]}
//         >
//           <div style={{ display: "flex", justifyContent: "start" }}>
//             <div>
//               <p
//                 style={{
//                   margin: 5,
//                   color: "darkgray",
//                   paddingTop: 10,
//                   fontFamily: 'Content',
//                 }}
//               >
//                 ឈ្មោះផ្នែក / Deparment Name
//               </p>

//               <Select
//                 style={{ width: 250 }}
//                 // showSearch
//                 placeholder="Select a department"
//                 // optionFilterProp="children"
//                 onChange={onChangeDepartmentNew}
//                 value={code}
//               >
//                 {listdepart.map((option) => (
//                   <Option
//                     className="styleTageStatusForm"
//                     key={option.code}
//                     value={option.code}
//                   >
//                     {option.code} {"-"} {option.department_name}{" "}
//                     {/* Replace with the field from your MySQL table */}
//                   </Option>
//                 ))}
//               </Select>

//               <p
//                 style={{
//                   margin: 5,
//                   color: "darkgray",
//                   paddingTop: 10,
//                   fontFamily: 'Content',
//                 }}
//               >
//                 តួរនាទី ភាសាខ្មែរ / Position in Khmer
//               </p>

//               <Input.TextArea
//                 className="styleTageStatusForm"
//                 rows={2}
//                 placeholder="input description"
//                 value={position_kh}
//                 onChange={onChangeKH}
//                 style={{ width: 250 }}
//               />

//               <p
//                 style={{
//                   margin: 5,
//                   color: "darkgray",
//                   paddingTop: 10,
//                   fontFamily: 'Content',
//                 }}
//               >
//                 តួរនាទី English
//               </p>

//               <Input.TextArea
//                 className="styleTageStatusForm"
//                 rows={2}
//                 placeholder="input other"
//                 value={position_en}
//                 onChange={onChangeEN}
//                 style={{ width: 250 }}
//               />

//               <p
//                 style={{
//                   margin: 5,
//                   color: "darkgray",
//                   paddingTop: 10,
//                   fontFamily: 'Content',
//                 }}
//               >
//                 ផ្សេងៗ / Other
//               </p>
//               <Input.TextArea
//                 className="styleTageStatusForm"
//                 rows={4}
//                 placeholder="input other"
//                 value={other}
//                 onChange={onChangeOther}
//                 style={{ width: 250 }}
//               />
//             </div>

//             <div style={{ paddingLeft: 20 }}>
//               <p
//                 style={{
//                   margin: 5,
//                   color: "darkgray",
//                   paddingTop: 10,
//                   fontFamily: 'Content',
//                 }}
//               >
//                 ស្ថានភាព / Status
//               </p>

//               <Tag>
//                 {" "}
//                 <div style={{ padding: 10 }}>
//                   <Checkbox
//                     checked={enable}
//                     onChange={handleCheckboxChange_Enable}
//                   >
//                     Enable
//                   </Checkbox>
//                   <Checkbox
//                     style={{ color: "red" }}
//                     checked={disable}
//                     onChange={handleCheckboxChange_Diable}
//                   >
//                     Disable
//                   </Checkbox>
//                 </div>
//               </Tag>
//             </div>
//           </div>
//         </Modal>

//         <Modal
//           title="លុបតួនារទីចេញពីប្រព័ន្ធ "
//           className="custom-form-item"
//           open={visableModelDelete}
//           onCancel={onCanceDelete}
//           footer={[
//             <div>
//               <Button onClick={onCLoseModelDelete}>No</Button>
//               <Button onClick={onComfirmModelDelete} type="primary">
//                 Yes
//               </Button>
//             </div>,
//           ]}
//         >
//           <p className="custom-form-item" style={{ color: "red" }}>
//             តើអ្នកចង់លុបផ្នែក ៖ {position} នេះចេញពីប្រព័ន្ធ ?
//           </p>
//         </Modal>
//       </div>
//     </div>
//   );
// };

// export default Position;



import { useEffect, useState } from "react";
import {
  PlusCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  UsergroupAddOutlined,
  EditFilled,
  DeleteFilled,
  ExclamationCircleOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import {
  Modal,
  Button,
  Form,
  Input,
  Select,
  Space,
  Tag,
  Checkbox,
  Pagination,
  Alert,
} from "antd";
import "../../styles/Home-module.css";
import styles from "../../styles/Font.css";
import { request } from "../../share/request";
import Table from "react-bootstrap/Table";
import { Stack } from "react-bootstrap";

import { openNotification } from "../../share/message";
import { getCurrentUser, getPermission } from "../../share/getProfile";
import { getTageStyle } from "../../share/getStatusContent";

import { boxHeader, boxHeaderTagText } from "../../styles/boxShadow";

const { Option } = Select;

const Position = () => {
  const getProfileOrg = getCurrentUser();
  const [list, setList] = useState([]);
  const [listdepart, setListDepart] = useState([]);
  const [id, setID] = useState("");
  const [position, setPosition] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadingSpin, setLoadingSpin] = useState(false);

  // Delete confirmation states
  const [confirmText, setConfirmText] = useState("");
  const [isConfirmDisabled, setIsConfirmDisabled] = useState(true);
  const CONFIRM_WORD = "POSITION";

  const [objFilter, setObjFilter] = useState({
    page: 1,
    department_code: "",
    org_code: getProfileOrg.org_code,
  });

  // -----------------  permisstion page --------------------
  const userPermission = getPermission();
  const positionValue = userPermission.find(
    (permission) => permission.pagename === "position"
  ) || { add: 0, edit: 0, deleted: 0 };
  const {
    add: addvalue,
    edit: Editvalue,
    deleted: deletevalue,
  } = positionValue;
  // -----------------  end permisstion page --------------------

  const getList = async (objFilter) => {
    const param = new URLSearchParams({
      page: objFilter.page,
      department_code: objFilter.department_code,
      org_code: getProfileOrg.org_code,
    });
    console.log("Parameters for department:", param.toString());
    try {
      await new Promise((resolve) => setTimeout(resolve, 400));
      const res = await request("position?" + param.toString(), "get", {});
      if (res) {
        setList(res.listPosition);
        setListDepart(res.listDepartment);
        setTotalPage(res.total_records);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList(objFilter);
  }, []);

  //-------------- page management ----------------------
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = list.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  //-------------------------------------------

  // ----------------- open modle ----------
  const [visableModelDelete, setVisableModeleDelete] = useState(false);
  
  const onDeleteModel = (item) => {
    setVisableModeleDelete(true);
    setID(item.id);
    setPosition(item.position_kh);
    // Reset confirmation state
    setConfirmText("");
    setIsConfirmDisabled(true);
  };

  const onCLoseModelDelete = () => {
    setVisableModeleDelete(false);
    setConfirmText("");
    setIsConfirmDisabled(true);
  };

  // Handle confirm text input change
  const handleConfirmTextChange = (e) => {
    const value = e.target.value;
    setConfirmText(value);
    setIsConfirmDisabled(value !== CONFIRM_WORD);
  };

  const onComfirmModelDelete = async () => {
    if (confirmText !== CONFIRM_WORD) {
      openNotification("warning", "Warning", `Please type "${CONFIRM_WORD}" to confirm deletion`);
      return;
    }
    
    console.log("ID delete is : " + id);
    setLoadingSpin(true);
    try {
      const res = await request("position/" + id, "delete", {});
      setVisableModeleDelete(false);
      setConfirmText("");
      setIsConfirmDisabled(true);
      if (res) {
        getList(objFilter);
        await new Promise((resolve) => setTimeout(resolve, 400));
        openNotification("success", "Success", "Delete Success!");
      } else {
        openNotification("error", "Error", "Delete failed!");
      }
    } catch (error) {
      console.error("Error deleting:", error);
      openNotification("error", "Error", "An error occurred while deleting");
    } finally {
      setLoadingSpin(false);
    }
  };
  // --------------- end model delete--------

  //---------------- statuse --------------
  const getStatusContent = (status) => {
    switch (status) {
      case 1:
        return (
          <Button
            type="primary"
            ghost
            shape="round"
            icon={<CheckCircleOutlined />}
          >
            {" "}
            Enable{" "}
          </Button>
        );
      case 0:
        return (
          <Button
            type="primary"
            danger
            ghost
            shape="round"
            icon={<ClockCircleOutlined />}
          >
            {" "}
            Disable{" "}
          </Button>
        );

      default:
        return null;
    }
  };
  // ------------- end status----------

  //------------- style tage --------
  const styleTageStatus = {
    fontSize: "14px",
    height: "30px",
    borderRadius: "30px",
    paddingTop: "5px",
    paddingLeft: "10px",
    paddingRight: "10px",
  };
  //---------------------------

  //------------- save ----------
  const [visableNewModel, setVisableNewModel] = useState(false);
  const onOpenSaveNew = () => {
    setID("");
    setVisableNewModel(true);
    setEnable(true);
    setDisable(false);

    setDepartment("");
    setPosition_KH("");
    setPosition_EN("");
    setOther("");
  };
  const onCLoseNewDataModel = () => {
    setVisableNewModel(false);
  };
  //-------------   enable and disable ---------------

  const [enable, setEnable] = useState(false);
  const [disable, setDisable] = useState(false);
  const handleCheckboxChange_Enable = (e) => {
    setEnable(e.target.checked);
    setDisable(false);
  };
  const handleCheckboxChange_Diable = (e) => {
    setDisable(e.target.checked);
    setEnable(false);
  };
  //--------------------------------------------

  //------------------- save data to position--------
  const [department, setDepartment] = useState("");
  const [code, setCode] = useState("");
  const [position_kh, setPosition_KH] = useState("");
  const [position_en, setPosition_EN] = useState("");
  const [other, setOther] = useState("");
  const [TotalPage, setTotalPage] = useState("");

  const onSaveData = async () => {
    setLoadingSpin(true);
    try {
      if (id === "") {
        var data = {
          code: code,
          position_kh: position_kh,
          position_en: position_en,
          des: other,
          status: enable === true ? 1 : disable === true ? 0 : 0,
          user_create: getProfileOrg.fullname,
        };
        const res = await request("position", "post", data);
        setVisableNewModel(false);
        if (res) {
          await new Promise((resolve) => setTimeout(resolve, 400));
          openNotification("success", "Success", "Save Position Success");
        } else {
          openNotification("error", "Error", "Save failed!");
        }
      } else {
        var data = {
          id: id,
          code: code,
          position_kh: position_kh,
          position_en: position_en,
          des: other,
          status: enable === true ? 1 : disable === true ? 0 : 1,
          user_create: getProfileOrg.fullname,
        };
        const res = await request("position", "put", data);
        setVisableNewModel(false);
        if (res) {
          await new Promise((resolve) => setTimeout(resolve, 400));
          openNotification("success", "Success", "Update Position Success");
        } else {
          openNotification("error", "Error", "Update failed!");
        }
      }
      getList(objFilter);
    } catch (error) {
      console.error("Error saving:", error);
      openNotification("error", "Error", "An error occurred");
    } finally {
      setLoadingSpin(false);
    }
  };

  const onChangeKH = (event) => {
    setPosition_KH(event.target.value);
  };
  const onChangeEN = (event) => {
    setPosition_EN(event.target.value);
  };
  const onChangeOther = (event) => {
    setOther(event.target.value);
  };
  const onChangeDepartment = async (value) => {
    setCode(value);
    console.log(value);
    setCurrentPage(1);
    try {
      setLoadingSpin(true);
      var objTmp = {
        ...objFilter,
        department_code: value,
        page: 1,
      };
      setObjFilter(objTmp);
      getList(objTmp);
      await new Promise((resolve) => setTimeout(resolve, 400));
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingSpin(false);
    }
  };
  const onChangeDepartmentNew = (value) => {
    setCode(value);
  };
  //--------------------

  //--------------- Eidt data ----------
  const onOpenEdit = (item) => {
    setID(item.id);
    setCode(item.code);
    setDepartment(item.code + " -" + item.department_name);
    setPosition_KH(item.position_kh);
    setPosition_EN(item.position_en);
    setOther(item.des);
    setVisableNewModel(true);
    if (item.status === 1) {
      setEnable(true);
      setDisable(false);
    } else {
      setEnable(false);
      setDisable(true);
    }
  };

  //-------------------------
  const onCancelModel = () => {
    setVisableNewModel(false);
  };
  const onCanceDelete = () => {
    setVisableModeleDelete(false);
    setConfirmText("");
    setIsConfirmDisabled(true);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const onShowSizeChange = async (current) => {
    console.log(current);
    setPageNumber(current);
    try {
      setLoadingSpin(true);
      var objTmp = {
        ...objFilter,
        page: current,
      };
      await new Promise((resolve) => setTimeout(resolve, 400));
      setObjFilter(objTmp);
      getList(objTmp);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingSpin(false);
    }
  };

  return (
    <div>
      <div className="sprinSave-container">
        {loadingSpin && (
          <div className="sprinSave">
            <GetLoading />
          </div>
        )}
      </div>

      <div style={boxHeader}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {boxHeaderTagText("ការគ្រប់គ្រង់ ព៏តមានតួនាទី")}
          <Select
            className="styleTageStatusForm"
            placeholder="Select an Deparment"
            style={{ width: 250 }}
            onChange={onChangeDepartment}
            allowClear
          >
            {listdepart.map((option) => (
              <Option
                className="styleTageStatusForm"
                key={option.code}
                value={option.code}
              >
                {option.department_name}
              </Option>
            ))}
          </Select>
        </div>
        <Button
          onClick={onOpenSaveNew}
          disabled={!addvalue}
          className="custom-form-item"
          type="primary"
          icon={<PlusCircleOutlined />}
        >
          បន្ថែមតួនាទីថ្មី
        </Button>
      </div>

      <div>
        {loading ? (
          <div className="sprinCustome">
            <GetLoading />
          </div>
        ) : (
          <Table className="rounded-table" itemsPerPage={10}>
            <thead>
              <tr className="table-success">
                <th>NO</th>
                <th>ផ្នែក</th>
                <th>តួនាទី ភាសាខ្មែរ</th>
                <th>តួនាទី English</th>
                <th>ផ្សេងៗ</th>
                <th>ស្ថានភាព</th>
                <th>អ្នកបង្កើត</th>
                <th>សកម្មភាព</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map((item, index) => (
                <tr key={index}>
                  <td>{10 * (pageNumber - 1) + (index + 1)}</td>
                  <td>{getTageStyle(item.department_name)}</td>
                  <td>{item.position_kh}</td>
                  <td>{item.position_en}</td>
                  <td>{item.des}</td>
                  <td>{getStatusContent(item.status)}</td>
                  <td>
                    <Tag
                      style={styleTageStatus}
                      icon={<UsergroupAddOutlined />}
                      color="green"
                    >
                      {item.user_create}
                    </Tag>
                  </td>

                  <td style={{ width: 100 }}>
                    <Stack gap={1} direction="horizontal">
                      <Button
                        icon={<EditFilled />}
                        disabled={!Editvalue}
                        type="primary"
                        onClick={() => onOpenEdit(item)}
                      />
                      <Button
                        icon={<DeleteFilled />}
                        disabled={!deletevalue}
                        type="primary"
                        onClick={() => onDeleteModel(item)}
                        danger
                      />
                    </Stack>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}

        <Pagination
          onChange={onShowSizeChange}
          defaultCurrent={currentPage}
          total={TotalPage}
        />

        {/* New/Edit Position Modal */}
        <Modal
          title={id === "" ? "New Position" : "Update Position"}
          className="styleTageStatusForm"
          open={visableNewModel}
          onCancel={onCancelModel}
          footer={[
            <div key="footer">
              <Space>
                <Button onClick={onCLoseNewDataModel}>Cancel</Button>
                <Button type="primary" onClick={onSaveData}>
                  {id === "" ? "Save" : "Update"}
                </Button>
              </Space>
            </div>,
          ]}
        >
          <div style={{ display: "flex", justifyContent: "start" }}>
            <div>
              <p
                style={{
                  margin: 5,
                  color: "darkgray",
                  paddingTop: 10,
                  fontFamily: 'Content',
                }}
              >
                ឈ្មោះផ្នែក / Department Name
              </p>

              <Select
                style={{ width: 250 }}
                placeholder="Select a department"
                onChange={onChangeDepartmentNew}
                value={code}
              >
                {listdepart.map((option) => (
                  <Option
                    className="styleTageStatusForm"
                    key={option.code}
                    value={option.code}
                  >
                    {option.code} {"-"} {option.department_name}
                  </Option>
                ))}
              </Select>

              <p
                style={{
                  margin: 5,
                  color: "darkgray",
                  paddingTop: 10,
                  fontFamily: 'Content',
                }}
              >
                តួរនាទី ភាសាខ្មែរ / Position in Khmer
              </p>

              <Input.TextArea
                className="styleTageStatusForm"
                rows={2}
                placeholder="Input position in Khmer"
                value={position_kh}
                onChange={onChangeKH}
                style={{ width: 250 }}
              />

              <p
                style={{
                  margin: 5,
                  color: "darkgray",
                  paddingTop: 10,
                  fontFamily: 'Content',
                }}
              >
                តួរនាទី English
              </p>

              <Input.TextArea
                className="styleTageStatusForm"
                rows={2}
                placeholder="Input position in English"
                value={position_en}
                onChange={onChangeEN}
                style={{ width: 250 }}
              />

              <p
                style={{
                  margin: 5,
                  color: "darkgray",
                  paddingTop: 10,
                  fontFamily: 'Content',
                }}
              >
                ផ្សេងៗ / Other
              </p>
              <Input.TextArea
                className="styleTageStatusForm"
                rows={4}
                placeholder="Input other details"
                value={other}
                onChange={onChangeOther}
                style={{ width: 250 }}
              />
            </div>

            <div style={{ paddingLeft: 20 }}>
              <p
                style={{
                  margin: 5,
                  color: "darkgray",
                  paddingTop: 10,
                  fontFamily: 'Content',
                }}
              >
                ស្ថានភាព / Status
              </p>

              <Tag>
                <div style={{ padding: 10 }}>
                  <Checkbox
                    checked={enable}
                    onChange={handleCheckboxChange_Enable}
                  >
                    Enable
                  </Checkbox>
                  <Checkbox
                    style={{ color: "red" }}
                    checked={disable}
                    onChange={handleCheckboxChange_Diable}
                  >
                    Disable
                  </Checkbox>
                </div>
              </Tag>
            </div>
          </div>
        </Modal>

        {/* Delete Confirmation Modal with Type-to-Confirm */}
        <Modal
          title={
            <Space>
              <ExclamationCircleOutlined style={{ color: '#ff4d4f', fontSize: '20px' }} />
              <span style={{ color: '#ff4d4f' }}>Confirm Deletion</span>
            </Space>
          }
          className="custom-form-item"
          open={visableModelDelete}
          onCancel={onCanceDelete}
          footer={[
            <div key="delete-footer" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <Button onClick={onCLoseModelDelete}>Cancel</Button>
              <Button 
                onClick={onComfirmModelDelete} 
                type="primary" 
                danger
                disabled={isConfirmDisabled}
                icon={<DeleteFilled />}
              >
                Delete Position
              </Button>
            </div>,
          ]}
          width={520}
        >
          <div style={{ padding: '16px 0' }}>
            <Alert
              message="Warning"
              description={
                <span>
                  This action <strong>cannot be undone</strong>. This will permanently delete the position.
                </span>
              }
              type="warning"
              showIcon
              icon={<WarningOutlined />}
              style={{ marginBottom: 20 }}
            />
            
            <div style={{ 
              background: '#fff2f0', 
              border: '1px solid #ffccc7', 
              borderRadius: 8, 
              padding: '12px 16px',
              marginBottom: 20 
            }}>
              <p style={{ margin: 0, color: '#333', fontSize: 14, fontFamily: 'Content' }}>
                តើអ្នកចង់លុបតួនាទី <strong style={{ color: '#ff4d4f' }}>"{position}"</strong> នេះចេញពីប្រព័ន្ធ ?
              </p>
            </div>

            <div style={{ 
              background: '#fafafa', 
              border: '1px solid #d9d9d9', 
              borderRadius: 8, 
              padding: '16px',
            }}>
              <p style={{ 
                margin: '0 0 8px 0', 
                fontSize: 13, 
                color: '#666',
                fontWeight: 500 
              }}>
                Please type <strong style={{ 
                  color: '#ff4d4f', 
                  background: '#fff2f0', 
                  padding: '2px 8px', 
                  borderRadius: 4,
                  fontFamily: 'monospace',
                  fontSize: 14,
                  letterSpacing: 2
                }}>{CONFIRM_WORD}</strong> to confirm:
              </p>
              
              <Input
                placeholder={`Type "${CONFIRM_WORD}" to confirm`}
                value={confirmText}
                onChange={handleConfirmTextChange}
                size="large"
                style={{ 
                  fontFamily: 'monospace',
                  letterSpacing: 2,
                  fontWeight: 'bold'
                }}
                status={confirmText && confirmText !== CONFIRM_WORD ? 'error' : ''}
                prefix={
                  confirmText === CONFIRM_WORD ? 
                    <CheckCircleOutlined style={{ color: '#52c41a' }} /> : 
                    <ExclamationCircleOutlined style={{ color: '#faad14' }} />
                }
                onPressEnter={() => {
                  if (confirmText === CONFIRM_WORD) {
                    onComfirmModelDelete();
                  }
                }}
              />
              
              {confirmText && confirmText !== CONFIRM_WORD && (
                <p style={{ 
                  color: '#ff4d4f', 
                  fontSize: 12, 
                  marginTop: 8,
                  marginBottom: 0 
                }}>
                  Text does not match. Please type exactly "{CONFIRM_WORD}"
                </p>
              )}
              
              {confirmText === CONFIRM_WORD && (
                <p style={{ 
                  color: '#52c41a', 
                  fontSize: 12, 
                  marginTop: 8,
                  marginBottom: 0 
                }}>
                  Confirmation text matched. You can now delete.
                </p>
              )}
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default Position;